<template>
    <div class="innerBox" style="border-radius: 16px;">

        <div class="row">
            <div class="col-md-6">
                <span class="section--title">Tracking Unit</span>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-6 col-md-3 offset-md-9" style="padding: 0 10px">
                        <button
                            class="btn btn-dh-download"
                            @click="rawData != null ? exportCsv(rawData, filter.engine_no + ' tracking data') : errorSwal('Data Empty')"
                        >Download CSV&nbsp;&nbsp;<i class="fas fa-download"></i></button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-4">
                <div class="row">
                    <div class="col-8">
                        <div class="form-group form--elegant">
                            <label for="noEngine">Masukan No Engine</label>
                            <input type="text" class="form-control" id="noEngine" placeholder="123456" v-model="filter.engine_no">
                        </div>
                    </div>
                    <div class="col-4 align-end">
                        <button class="btn mpm-button w-100" @click="fetchData">Track</button>
                    </div>
                </div>
            </div>
            <div class="col-md align-end" style="padding-bottom: 20px;">
                <div>
                    <h3 class="info--title">Type & Tahun Pembuatan</h3>
                    <p class="info--content">{{tipeDanTahun}}</p>
                </div>
            </div>
            <div class="col-md align-end" style="padding-bottom: 20px;" :class="{'text-right justify-end' : !isMobile}">
                <div>
                    <h3 class="info--title">Lokasi Saat Ini</h3>
                    <p class="info--content">{{currentLocation}}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                
                <table class="table activityTable" v-if="firstLoad">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Date</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="act in data">
                            <td><i class="fas" :class="act.icon"></i></td>
                            <td>{{ moment(act.scan_date).format("DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ act.activity }}</td>
                        </tr>
                    </tbody>
                </table>

                <div style="min-height: 300px; display: flex; align-items: center; justify-content: center;" v-else>
                    <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey; color: #585858">Masukan No Engine & Klik Track untuk memulai</p>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
    import qs from 'qs'
    import moment from 'moment'

    export default {
        data () {
            return {
                isMobile : this.isMobile(),
                moment : moment,

                firstLoad : false,

                iconDictionary : {
                    "mapengineqr" : "fa-qrcode",
                    "pkb" : "fa-clipboard-list",
                    "vehicle claim" : "fa-user-friends",
                    "md to dealer" : "fa-truck-moving",
                    "pengiriman unit ke konsumen" : "fa-truck-pickup",
                    "penerimaan gudang" : "fa-archive",
                    "spg" : "fa-box",
                    "movement unit 1" : "fa-people-carry",
                    "shipment outgoing" : "fa-truck-loading",
                    "transfer unit in" : "fa-parachute-box",
                    "movement site receive" : "fa-pallet",
                },

                filter : {
                    engine_no : '',
                },
                rawData : null,
                data : null,

                activity : [
                    {status : 'Delivered to Customer (Rudi Sentosa)', date : '2019-06-06 18:38:20', icon : 'fas fa-user'},
                    {status : 'Sold to Customer (SSU)', date : '2019-06-05 10:11:30', icon : 'fas fa-city'},
                    {status : 'Goods Received Dealer', date : '2019-06-04 14:25:21', icon : 'fas fa-city'},
                    {status : 'In-Transit MD to Dealer', date : '2019-05-28 13:12:11', icon : 'fas fa-truck'},
                    {status : 'Transfer ke Gudang MD', date : '2019-05-26 16:31:32', icon : 'fas fa-store-alt'},
                    {status : 'Shipping List Main Dealer', date : '2019-05-24 08:41:20', icon : 'fas fa-store-alt'},
                    {status : 'Invoice MD to Dealer', date : '2019-05-23 16:25:12', icon : 'fas fa-store-alt'},
                    {status : 'Purchase Order ke Main Dealer', date : '2019-05-22 14:11:51', icon : 'fas fa-city'}
                ],
            }
        },
        mounted () {

        },
        computed : {
            tipeDanTahun () {
                if (!this.firstLoad) return "-";
                if (this.data == null || this.data.length == 0) return "No Data";

                let lastPos = this.data.length-1;

                return `${this.data[lastPos].type_name ? this.data[lastPos].type_name : '-'} • ${this.data[lastPos].color_description ? this.data[lastPos].color_description : '-'} • ${this.data[lastPos].manufacture_year ? this.data[lastPos].manufacture_year : '-'}`;
            },
            currentLocation () {
                if (!this.firstLoad) return "-";
                if (this.data == null || this.data.length == 0) return "No Data";

                return `${this.data[0].owner_address ? this.data[0].owner_address : this.data[0].location_address}${this.data[0].owner_name ? ' ('+this.data[0].owner_name+')' : ''}`
            }
        },
        methods : {
            fetchData () {

                if (this.filter.engine_no == null || this.filter.engine_no == "") {
                    this.$swal.fire({
                        'title' : 'Error!',
                        'text' : `Engine Number tidak boleh kosong`,
                        'icon' : 'error'
                    })
                    return;
                }

                this.data = null;
                this.rawData = null;

                this.$http.get(`/api/highlight-dealer/tracking${qs.stringify(this.filter, {skipNulls:true, addQueryPrefix:true})}`)
                .then((resp)=>{
                    let data = resp.data.data;
                    this.rawData = JSON.parse(JSON.stringify(resp.data.data));

                    for (var i in data) {
                        data[i].icon = this.iconDictionary[data[i].activity.toLowerCase()] ? this.iconDictionary[data[i].activity.toLowerCase()] : 'fa-question';
                    }

                    this.data = data;
                    this.firstLoad = true;
                })
                .catch((err)=>{console.log(err)})
            },
        }
    }
</script>

<style scoped>
    .align-end {
        display: flex;
        align-items: flex-end;
    }

    .justify-end {
        justify-content: flex-end;
    }

    .form--elegant {
        margin: 0;
    }

    .form--elegant label {
        font: normal normal 500 16px/18px Ubuntu;
        color: #C1C1C1;
    }

    .form--elegant input[type='text'] {
        width: 100%;
        border: 1px solid #dedede;
        border-radius: 6px;
        text-align: center;

        font: normal normal 500 20px/24px Ubuntu;
        color: #7B7B7B;
        height: 42px;
    }    
    .form--elegant input[type='text']::placeholder {
        color: #C1C1C1;   
    }

    .mpm-button {
        background: #F36F21;
        color: white;
        font: normal normal 500 20px/24px Ubuntu;
        height: 42px;
    }

    .info--title {
        font: normal normal 500 20px/24px Ubuntu;
        color: #7B7B7B;
    }

    .info--content {
        font: normal normal 500 16px/18px Ubuntu;
        color: #C1C1C1;
        margin: 0;
    }

    .activityTable tr th {
        font: normal normal 500 16px/18px Ubuntu;
        color: #C1C1C1;
    }

    .activityTable tr td {
        font: normal normal 500 16px/18px Ubuntu;
        color: #7B7B7B;
        padding: 25px 8px;
        vertical-align: middle;
    }

    .activityTable tr td:first-child{
        color: #FFB182;
        font-size:  2rem;
        border-top: 0;
        text-align: center;
        position: relative;
    }

    .activityTable tr:not(:last-child) td:first-child::after {
        position: absolute;

        bottom: -30%;
        left: 50%;
        transform: translate(-50%, -50%);

        content : '';
        width: 2px;
        height: 1.5rem;
        background: #FFB182;
    }
</style>